import { createAppAsyncThunk } from '../../store/extensions';
import {
  IsabelCheckSymptomsRequest,
  IsabelSaveToMyJourneyRequest,
} from './models';
import { IsabelKnowledgeUrlsRequest } from './models/IsabelKnowledgeUrlsRequest';
import { IsabelTriageScoreRequest } from './models/IsabelTriageScoreRequest';
import {
  checkIsabelDiagnosesCall,
  fetchIsabelCountriesCall,
  getKnowledgeUrlsCall,
  getTriageScoreCall,
  saveToMyJourneyCall,
} from './service';

export const checkIsabelDiagnoses = createAppAsyncThunk(
  'healthjourney/isabel/checkSymptoms',
  (isabelCheckSymptomsRequest: IsabelCheckSymptomsRequest) => {
    return checkIsabelDiagnosesCall(isabelCheckSymptomsRequest);
  }
);

export const fetchIsabelCountries = createAppAsyncThunk(
  'healthjourney/isabel/countries',
  () => {
    return fetchIsabelCountriesCall();
  }
);

export const getTriageScore = createAppAsyncThunk(
  'healthjourney/isabel/getTriageScore',
  (isabelTriageScoreRequest: IsabelTriageScoreRequest) => {
    return getTriageScoreCall(isabelTriageScoreRequest);
  }
);

export const getKnowledgeUrls = createAppAsyncThunk(
  'healthjourney/isabel/getKnowledgeUrls',
  (isabelKnowledgeUrlsRequest: IsabelKnowledgeUrlsRequest) => {
    return getKnowledgeUrlsCall(isabelKnowledgeUrlsRequest);
  }
);

export const saveToMyJourney = createAppAsyncThunk(
  'healthjourney/isabel/saveToMyJourney',
  (args: {
    journeyId: string;
    isabelSaveToMyJourneyRequest: IsabelSaveToMyJourneyRequest;
  }) => {
    return saveToMyJourneyCall(
      args.journeyId,
      args.isabelSaveToMyJourneyRequest
    );
  }
);
